import { getLocale } from "../runtime";

const sv_searchresults = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Visa ${inputs.value} resultat`
};

const searchresults = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_searchresults(inputs)
	return "searchResults";
};

export { searchresults as "searchResults" };